// Metric definitions
export type MetricKey = 'impressions' | 'clicks' | 'cost' | 'revenue' | 'ecpm' | 'reads' | 'clickouts'

export interface Metric {
  key: MetricKey
  label: string
  measure: string
  formatter: (value: number) => string
  color: string
  yAxisID?: string
}

export const METRICS: Metric[] = [
  {
    key: 'impressions',
    label: 'Impressions',
    measure: 'aggregateTdLevel.tdImpressions',
    formatter: (v) => v.toLocaleString(),
    color: '#3b82f6'
  },
  {
    key: 'clicks',
    label: 'Clicks', 
    measure: 'aggregateTdLevel.tdClicks',
    formatter: (v) => v.toLocaleString(),
    color: '#10b981'
  },
  {
    key: 'reads',
    label: 'Reads',
    measure: 'aggregateTdLevel.reads',
    formatter: (v) => v.toLocaleString(),
    color: '#06b6d4'
  },
  {
    key: 'clickouts',
    label: 'Clickouts',
    measure: 'aggregateTdLevel.clickouts',
    formatter: (v) => v.toLocaleString(),
    color: '#84cc16'
  },
  {
    key: 'cost',
    label: 'Cost',
    measure: 'aggregateTdLevel.totalCost',
    formatter: (v) => `DKK ${v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
    color: '#f59e0b'
  },
  {
    key: 'revenue',
    label: 'Revenue',
    measure: 'aggregateTdLevel.publisherRevenue',
    formatter: (v) => `DKK ${v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
    color: '#8b5cf6'
  },
  {
    key: 'ecpm',
    label: 'eCPM',
    measure: 'aggregateTdLevel.eCpm',
    formatter: (v) => `DKK ${v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
    color: '#ef4444',
    yAxisID: 'y1' // Right axis for eCPM
  }
]

export type TimeGranularity = 'day' | 'week' | 'month'

export interface PerformanceChartProps {
  selectedCampaignIds: string[]
  selectedCampaignNames: Record<string, string> // id -> name mapping
}

export interface ChartDataPoint {
  [key: string]: number
}

export interface SummaryData {
  [key: string]: number
}
